import type { Zone } from './zones.js';

/**
 * Весь баланс удара — здесь. Логика (shot.ts) только комбинирует эти числа.
 * Смысл: верхние углы почти не берутся, но чаще летят мимо и в штангу; центр надёжен, но легко читается;
 * точный удар (PERFECT) реже промахивается и хуже берётся; перебор силы — промах, слабый удар — лёгкий сейв.
 */
export interface ZoneBalance {
  /** шанс промаха при GOOD и нормальной силе */
  miss: number;
  /** доля промахов, попадающих в штангу или перекладину (остальные — мимо) */
  postShare: number;
  /** шанс сейва, если вратарь прыгнул в эту же зону */
  saveSame: number;
  /** шанс сейва, если вратарь в соседней зоне по горизонтали или вертикали (по диагонали — 0) */
  saveNear: number;
}

export const ZONE_BALANCE: Readonly<Record<Zone, ZoneBalance>> = {
  TL: { miss: 0.16, postShare: 0.4, saveSame: 0.45, saveNear: 0.12 },
  TC: { miss: 0.1, postShare: 0.45, saveSame: 0.75, saveNear: 0.22 },
  TR: { miss: 0.16, postShare: 0.4, saveSame: 0.45, saveNear: 0.12 },
  ML: { miss: 0.07, postShare: 0.4, saveSame: 0.65, saveNear: 0.2 },
  MC: { miss: 0.02, postShare: 0, saveSame: 0.92, saveNear: 0.3 },
  MR: { miss: 0.07, postShare: 0.4, saveSame: 0.65, saveNear: 0.2 },
  BL: { miss: 0.08, postShare: 0.35, saveSame: 0.65, saveNear: 0.18 },
  BC: { miss: 0.02, postShare: 0, saveSame: 0.9, saveNear: 0.25 },
  BR: { miss: 0.08, postShare: 0.35, saveSame: 0.65, saveNear: 0.18 },
};

export const BALANCE = {
  zones: ZONE_BALANCE,
  /** качество удара по точности индикатора: от perfect — PERFECT, от good — GOOD, иначе BAD */
  quality: { perfect: 0.9, good: 0.6 },
  /** множители шанса промаха и сейва по качеству удара */
  missByQuality: { PERFECT: 0.3, GOOD: 1, BAD: 2.2 },
  saveByQuality: { PERFECT: 0.7, GOOD: 1, BAD: 1.25 },
  /** сила выше порога добавляет промах: (power − threshold) × perUnit, для верхнего ряда ×topRowFactor */
  overpower: { threshold: 0.8, perUnit: 0.6, topRowFactor: 1.5 },
  /** множитель сейва от силы: base − slope × power (0,5 → ×1, 1 → ×0,8, 0 → ×1,2) */
  savePower: { base: 1.2, slope: 0.4 },
  /** множитель сейва от реакции вратаря: base + slope × reaction (0,5 → ×1) */
  saveReaction: { base: 0.85, slope: 0.3 },
  /** потолки: промах и сейв не бывают гарантированными */
  maxMiss: 0.9,
  maxSave: 0.97,
} as const;

export type Balance = typeof BALANCE;
